module.exports = __webpack_public_path__ + "static/media/instagram-container-black.26da99da.svg";